import { type EditFacilityInputType } from '@shelflix/schemas/facility/edit';
import { create } from 'zustand';

interface FacilityFormStore {
  formData: Partial<EditFacilityInputType>;
  setFormData: (data: Partial<EditFacilityInputType>) => void;
  resetForm: () => void;
}

export const useFacilityFormStore = create<FacilityFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
